<template>
  <DataListStateful
    title="Экспедиторы"
    resource="forwarders"
    store="forwarders"
    :columns="columns"
    :filter-options="filter"
  />
</template>

<script>
export default {
  data() {
    return {
      columns: [
        { title: "Ид", name: "id", sortable: false },
        { title: "Наименование", name: "title", sortable: true },
        { title: "Адрес", name: "address", sortable: true },
        { title: "Контактная информация", name: "contactInfo", sortable: true },
      ],
      filter: {
        title: {
          title: "Наименование",
          type: "text",
        },
        address: {
          title: "Адрес",
          type: "text",
        },
        contactInfo: {
          title: "Контактная информация",
          type: "text",
        },
      },
    };
  },
};
</script>
